import { withWhiteSwatch } from "./swatchPalette";

// Preset solid colours for the theme colour pickers (Gallery Theme, LinkVault,
// Business Box). withWhiteSwatch puts #FFFFFF first (Gordon law 2026-09-16).
export const colors = withWhiteSwatch([
  "#F32A00",
  "#F79A00",
  "#86BB00",
  "#29C18C",
  "#F5CC3B",
  "#123051",
  "#77CCCD",
  "#AAABAD",
  "#E25297",
  "#99439D",
  "#C9C4B4",
  "#F79781",
  "#F8CD80",
  "#C4DD81",
  "#94DAC1",
  "#FFEDAE",
  "#8BA6C2",
  "#BBE6E7",
  "#D6D7D8",
  "#E9ADCA",
  "#CCA3CF",
  "#F0EADB",
]);

// Gradient wallpaper presets. These are raw CSS `background` strings stored in
// `bg_wallpaper` (currentBg === 3) and rendered verbatim — zero network, instant.
// The full curated library (legacy presets + ~36 new mood-grouped gradients)
// lives in ./wallpaperGradients.js. Re-exported here as `gradients` so every
// existing import site keeps working unchanged.
export {
  CURATED_GRADIENTS as gradients,
  GRADIENT_GROUPS,
  GRADIENT_NAME_BY_VALUE,
  LEGACY_GRADIENTS,
} from "./wallpaperGradients";
